import styled from 'styled-components';

export const Number = styled.span`
  display: inline-block;
  font-family: 'Consolas';
  font-size: inherit;
  color: inherit;
`;
